import { render, staticRenderFns } from "./location-practitioners.vue?vue&type=template&id=d96f93aa&"
import script from "./location-practitioners.vue?vue&type=script&lang=ts&"
export * from "./location-practitioners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports